import { Action } from "redux";

export const GET_BEACONS_FOR_ORGANIZATION_FAIL =
  "BEACON:GET_BEACONS_FOR_ORGANIZATION_FAIL";

export interface GetBeaconsForOrganizationFailAction extends Action {
  type: typeof GET_BEACONS_FOR_ORGANIZATION_FAIL;
  organizationKeyName: string;
}

export const getBeaconsForOrganizationFailAction = (
  organizationKeyName: string
): GetBeaconsForOrganizationFailAction => ({
  type: GET_BEACONS_FOR_ORGANIZATION_FAIL,
  organizationKeyName,
});
